/** @jsx jsx */
import { jsx, css } from "@emotion/core"
import { useContext, useMemo } from "react"
import { useRouteMatch, useHistory } from "react-router-dom"
import AuthContext from "../../context/AuthContext"
import { ButtonGroup, Button, Badge } from "@material-ui/core"
import ListIcon from "@material-ui/icons/ListRounded"
import ShoppingCartRoundedIcon from "@material-ui/icons/ShoppingCartRounded"
import PeopleAltRoundedIcon from "@material-ui/icons/PeopleAltRounded"
import LocalOfferRoundedIcon from "@material-ui/icons/LocalOfferRounded"
import AssignmentRoundedIcon from "@material-ui/icons/AssignmentRounded"
import { useCartState } from "../../context/CartContext"
import { sumOrderValue } from "../Orders/orderUtils"
import { createPriceValueString } from "../utils/utils"

function OrganizationNavBar() {
    const { url } = useRouteMatch()
    const auth = useContext(AuthContext)
    const history = useHistory()
    const { cart } = useCartState()

    const sumValue = useMemo(() => sumOrderValue(cart), [cart])
    const numberOfItems = Object.keys(cart).length

    const handleNav = (to: string) => () => {
        history.push(to)
    }

    return (
        <nav css={styles.root}>
            <ButtonGroup
                variant="contained"
                color="primary"
                size="large"
                aria-label="contained primary button group"
            >
                <Button
                    startIcon={<ListIcon />}
                    onClick={handleNav(`${url}/products`)}
                    data-testid="navigation_products"
                >
                    Termékek
                </Button>
                {auth?.role === "admin" && (
                    <Button
                        startIcon={<PeopleAltRoundedIcon />}
                        onClick={handleNav(`${url}/users`)}
                        data-testid="navigation_users"
                    >
                        Vevők
                    </Button>
                )}
                {auth?.role === "admin" && (
                    <Button
                        startIcon={<LocalOfferRoundedIcon />}
                        onClick={handleNav(`${url}/discounts`)}
                        data-testid="navigation_discounts"
                    >
                        Kedvezmények
                    </Button>
                )}
                <Button
                    startIcon={<AssignmentRoundedIcon />}
                    onClick={handleNav(`${url}/orders`)}
                    data-testid="navigation_orders"
                >
                    Rendelések
                </Button>

                <Button
                    onClick={handleNav(`${url}/cart`)}
                    data-testid="navigation_cart"
                >
                    <div css={styles.orderButton}>
                        <Badge
                            css={styles.numberOfItems}
                            badgeContent={numberOfItems}
                            color="error"
                        >
                            <ShoppingCartRoundedIcon />
                        </Badge>
                        Kosár
                        {sumValue > 0 && (
                            <span>{`(${createPriceValueString(
                                sumValue,
                                "HUF"
                            )})`}</span>
                        )}
                    </div>
                </Button>
            </ButtonGroup>
        </nav>
    )
}

export default OrganizationNavBar

const styles = {
    root: css`
        position: fixed;
        width: 100%;
        top: 0;
        text-align: center;
        left: 0;
        z-index: 100;
    `,
    orderButton: css`
        display: flex;
        column-gap: 1rem;
    `,
    numberOfItems: css`
        .MuiBadge-anchorOriginTopRightRectangle {
            right: -3px;
            top: 13px;
            border: 2px solid #dc2626;
            padding: 0 4px;
        }
    `,
}
